"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkExactLengthPatternExists = exports.exactLengthPattern = void 0;
exports.exactLengthPattern = function (length) {
    return "^.{" + length + "," + length + "}$";
};
exports.checkExactLengthPatternExists = function () {
    return '\\^\\.\\{(.*?)\\,(.*?)}\\$';
};
exports.default = {
    checkExactLengthPatternExists: exports.checkExactLengthPatternExists,
    exactLengthPattern: exports.exactLengthPattern,
};
